export const SET_CATEGORIES_TREE = "setCategoriesTree";
export const CLEAR_CATEGORIES_TREE = "clearCategoriesTree";
export const SET_CATEGORIES = "setCategories";
export const CLEAR_CATEGORIES = "clearCategories";
export const SET_CATEGORY = "setCategory";
export const CLEAR_CATEGORY = "clearCategory";
export const SET_PARENT = "setParent";
export const SET_NAME = "setName";
export const SET_COLOR = "setColor";
